import { CommonModule, DatePipe } from "@angular/common";
import { effect } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SimpleChanges } from "@angular/core";
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  OnChanges,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  BehaviorSubject,
} from "rxjs";
import { TaskSummaryComponent } from "../../task-summary/task-summary.component";
import { Calendar } from "primeng/calendar";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericRequestDto } from "../../../../core/models/generic-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { GetAllBuyersResponseDto } from "../../../../core/models/orders/getAllBuyersResponseDto";
import { AddTaskNotes } from "../../../../core/models/task-management/addTaskNotesDto";
import { AddTaskOrder } from "../../../../core/models/task-management/addTaskOrderDto";
import { GetAllTaskResponse } from "../../../../core/models/task-management/getAllTaskResponseDto";
import { ProjectWorkflowDetail } from "../../../../core/models/task-management/getProjectWorkFlowDetailDto";
import { UpdateTaskPriority } from "../../../../core/models/task-management/updatePriorityDto";
import { UpdateTaskLine } from "../../../../core/models/task-management/updateTaskLineDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { SharedService } from "../../../../core/services/shared.service";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { PriorityTypeEnums } from "../../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../../shared/enums/taskTypeEnum";
import { ViewTypeEnum } from "../../../../shared/enums/viewTypeEnum";
import { WorkflowStatusEnum } from "../../../../shared/enums/workflowStatusEnum";
import { avatarUserDetailsDto } from "../../../../core/models/task-management/avatar-user-details";
import { UserAvatarDetailsComponent } from "../../user-avatar-details/user-avatar-details.component";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { DomSanitizer } from "@angular/platform-browser";
import { GetUserAvatarDetailsDto } from "../../../../core/models/users/users/getUserAvatarDetailsDto";
import { GetAllAssignedUsers } from "../../../../core/models/task-management/getAllAssignedUsersDto";

import {
  getTextColorForName,
  getColorForName,
  replaceString,
} from "../../../../shared/globalfunction";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ProjectWorkflowService } from "../../../../core/services/project-workflow.service";
import { SidebarService } from "../../../../core/services/sidebar.service";
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowReorderEvent,
} from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ProductionWorkflowSummaryComponent } from "../../../project-workflow/production-workflow-summary/production-workflow-summary.component";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import { ConfirmChangeComponent } from "../../../../shared/components/confirm-change/confirm-change.component";
import { DialogModule } from "primeng/dialog";
import { FormsModule } from "@angular/forms";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { Popover, PopoverModule } from "primeng/popover";
import { FilterMetadata } from "primeng/api";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { createCommentDto } from "../../../../core/models/task-management/createCommentDto";
import { TooltipModule } from "primeng/tooltip";
import { TaskHeaderEditComponent } from "../../task-header-edit/task-header-edit.component";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";

@UntilDestroy()
@Component({
  selector: "jni-list-view",
  templateUrl: "./list-view.component.html",
  styleUrls: ["./list-view.component.scss"],
  imports: [
    CheckboxModule,
    TableModule,
    CommonModule,
    DatePickerModule,
    SelectModule,
    ModalStackerComponent,
    ProductionWorkflowSummaryComponent,
    TaskSummaryComponent,
    ConfirmDialogComponent,
    ConfirmChangeComponent,
    DialogModule,
    FormsModule,
    SpinnerComponent,
    PopoverModule,
    TooltipModule,
    UserAvatarDetailsComponent,
    TaskHeaderEditComponent,
    AddContactInformationComponent,
  ],
})
export class ListViewComponent implements OnInit, OnChanges {
  taskIdSelected = 0;
  @ViewChild("TaskSummary", { static: false }) child!: TaskSummaryComponent;
  @ViewChild("calendar") calendar!: Calendar; // Get reference to the calendar component
  @Input() globalFilter!: GenericFilterRequestDto[];
  @Input() taskType!: number;
  @Input() clearColumns!: BehaviorSubject<boolean>;
  @Input() assignedUsers!: string[];
  @Input() myTasks!: boolean;
  @Input() archivedTasks!: boolean;
  @Input() bulkArchive!: boolean;
  @Input() allAssignedUserList: GetAllAssignedUsers[] = [];
  products = [];
  displayAddTaskModal = false;
  displayTaskDetailModal = false;
  showTaskModal = false;
  showSummarykModal = false;
  displaySidebar = false;
  showEditTaskModal = false;
  taskList: GetAllTaskResponse[] = [];
  defaultTake = 50;
  totalRecords = 0;
  filterTextChanged: Subject<Event> = new Subject<Event>();
  //priorityType: any;
  filterDebounceTime = 1000;
  showSmallLoader = false;
  showNotesModal = false;
  taskId = 0;
  notes = "";
  displayProdWorkflowSummary = false;
  workflowId = 0;
  currentDate = new Date();
  salesOrderId = "";
  ownerList: { name: string; personalNumber: string }[] = [];
  ownerListDefault: { name: string; personalNumber: string }[] = [];

  selectedProject: ProjectWorkflowDetail | null = null;
  selectedBuyer = "";
  buyerLists: GetAllBuyersResponseDto[] = [];
  buyerVendor$ = new Subject<string>();
  showAddBuyer = false;
  changeBuyerVisible = false;
  changeAlertVisible = false;
  changeAlertMessage =
    "The Buyer Name associated with the Project is {0}, do you want to update?";
  archiveMessage = "You want to mark <b>{0}</b> as {1}.";
  archiveAlertVisible = false;
  archivedTask = 0;
  archivedTaskStatus = false;

  productionStatusEnum = WorkflowStatusEnum;
  salesStatusEnum = EnumSalesTaskStatus;
  prodStatusDropDownList!: { label: string; value: number }[];
  @Output() showClearFilter = new EventEmitter<boolean>();
  @Output() displaySmallLoader = new EventEmitter<boolean>();
  showUserAvatarDetails = false;
  userAvatorDetails = {} as avatarUserDetailsDto;
  @ViewChild("userAvatarDetailsComp", { static: false })
  userAvatarDetailsComp!: UserAvatarDetailsComponent;
  @ViewChild("avatarUserPopover") avatarUserPopover!: Popover;

  @ViewChild("taskHeaderEdit", { static: false })
  taskHeaderEdit!: TaskHeaderEditComponent;
  displayAddContact = false;
  clientId = "";
  addClientContact: AddClientContact = {} as AddClientContact;
  currentAvatarTarget: HTMLElement | null = null;
  hideTimeout: ReturnType<typeof setTimeout> | null = null;
  columnsList = [
    { name: "tasktype", label: "Task Type", table: "UserTasks" },
    { name: "customeridd365", label: "Client", table: "workflowheaders" },
    { name: "jobname", label: "Job Name", table: "workflowheaders" },
    { name: "shipdated365", label: "ESD", table: "saleorderline" },
    { name: "inhanddated365", label: "IHD", table: "salesorderheader" },
    { name: "title", label: "Task", table: "UserTasks" },
    {
      name: "description",
      label: "Description",
      table: "UserTasks",
    },
    { name: "duedate", label: "Due Date", table: "UserTasks" },
    { name: "personnelnumber", label: "Assigned To", table: "taskassignments" },
    { name: "coowner", label: "Owner", table: "coowner" },
    { name: "notes", label: "Note", table: "projectworkflowline" },
    { name: "PriorityType", label: "Priority", table: "UserTasks" },
    { name: "Status", label: "State", table: "TaskStatus" },
    { name: "Id", label: "Link Project", table: "workflowheader" },
    { name: "CreatedDate", label: "Created Date", table: "UserTasks" },
    { name: "CreatedBy", label: "Created By", table: "UserTasks" },
  ];
  tableGlobalFilters: string[] = [
    "projectWorkflowId",
    "title",
    "description",
    "client",
    "jobName",
    "assignedTo",
    "createdBy",
    "taskPaddedId",
    "salesOrderId",
    "taskType",
    "status",
    "dueDate",
    "createdDate",
    "tags",
    "title",
    "description",
    "ihd",
    "esd",
    "notes",
    "owner",
  ];
  priorityTypeList!: string[];
  priorityEnum = PriorityTypeEnums;
  stateList: { name: string; value: number }[] = [];
  display = false;
  priorityList = [
    {
      id: 1,
      title: "Urgent",
      production: true,
      color: "#ff4d4d",
    },
    {
      id: 2,
      title: "Order",
      production: false,
      color: "#ffc966",
    },
    {
      id: 3,
      title: "Source",
      production: false,
      color: "#6666ff",
    },
    {
      id: 4,
      title: "Standard",
      production: true,
      color: "#ffffff",
    },
  ];

  //selectedPriority: any;
  statusList!: { label: string; value: string | EnumSalesTaskStatus }[];
  getAllState: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progress": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };
  private priorityLevel: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "Urgent",
    [PriorityTypeEnums.Source]: "Source",
    [PriorityTypeEnums.Order]: "Order",
    [PriorityTypeEnums.Standard]: "Standard",
  };

  private taskTypeKey: Record<number, string> = {
    [TaskTypeEnum.Sales]: "Sales",
    [TaskTypeEnum.Production]: "Production",
  };

  private taskStatusKeyPairsSales: Record<number, string> = {
    [EnumSalesTaskStatus.New]: "New",
    [EnumSalesTaskStatus.Blocked]: "Blocked",
    [EnumSalesTaskStatus.InProgress]: "In Progress",
    [EnumSalesTaskStatus.InReview]: "In Review",
    [EnumSalesTaskStatus.Closed]: "Closed",
  };

  taskStatusKeyPairsSalesByName: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progress": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };

  private taskStatusKeyPairsProduction: Record<number, string> = {
    [WorkflowStatusEnum.ALL]: "All",
    [WorkflowStatusEnum.Cancelled]: "Cancelled",
    [WorkflowStatusEnum.Complete]: "Complete",
    [WorkflowStatusEnum.Delivered]: "Delivered",
    [WorkflowStatusEnum.InProduction]: "In Production",
    [WorkflowStatusEnum.OrderWritten]: "Order Written",
    [WorkflowStatusEnum.PoSent]: "Po Sent",
    [WorkflowStatusEnum.ProjectCreated]: "Project Created",
    [WorkflowStatusEnum.ProofApproved]: "Proof Approved",
    [WorkflowStatusEnum.ProofSent]: "Proof Sent",
    [WorkflowStatusEnum.RevisionRequested]: "Revision Requested",
    [WorkflowStatusEnum.Shipped]: "Shipped",
  };

  salesTaskColorCodes: Record<string, { color: string; background: string }> = {
    "13": { color: "#00306f", background: "#6ac9f6" },
    "14": { color: "#7e0c14", background: "#ff898c" },
    "15": { color: "#6a6027", background: "#fff6ad" },
    "16": { color: "#00306f", background: "#6ac9f6" },
    "17": { color: "#007117", background: "#63f8b4" },
  };

  prodTaskColorCodes: Record<string, { color: string; background: string }> = {
    "2": { color: "#472106", background: "#ff7929" },
    "3": { color: "#0e0a05", background: "#e79f56" },
    "4": { color: "#196825", background: "#63f8b4" },
    "5": { color: "#6a6027", background: "#fff6ad" },
    "6": { color: "#5d3e11", background: "#f5d8a9" },
    "7": { color: "#498646", background: "#b0f2a9" },
    "12": { color: "#003a77", background: "#69c9f5" },
  };

  lazyLoadEvent: TableLazyLoadEvent = {};
  workflowStatusList!: Record<string, number>;
  showCalendar = false;
  buyerChange = false;
  isBarCollapse = false;
  originalTitle: string | null = null;
  originalClientNameWithout: string | null = null;
  originalBuyerNameWithout: string | null = null;
  isLoading = false;
  originalNickName: string | null = null;

  @Output() archivedList = new EventEmitter<GetAllTaskResponse[]>();
  @Output() disableBulkArchive = new EventEmitter<void>();
  constructor(
    private _taskManagement: TaskManagementService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private datePipe: DatePipe,
    private _sharedService: SharedService,
    private _workflowService: ProjectWorkflowService,
    private _samplepoListingService: SamplepoListingService,
    private _dataService: SidebarService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _profileFormService: ProfileFormService,
    private _domSanitizer: DomSanitizer, //
    private _msalApisService: MsalApiService
  ) {
    effect(() => {
      this.isBarCollapse = this._dataService.isCollapsed$();
    });

    this._route.params.subscribe(params => {
      if (params["id"]) {
        this.taskIdSelected = parseInt(params["id"]);
      }
    });
  }

  ngOnInit(): void {
    this.currentDate.setHours(0, 0, 0, 0);
    this.statusList = this.getSalesTaskAsList();
    this.getWorkflowStatusList();
    this.priorityTypeList = this.prioirtyKeys();
    this.stateList = this.stateKeys();
    if (this.taskIdSelected !== 0) {
      this.redirectToTaskSummary(this.taskIdSelected);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["myTasks"] && changes["myTasks"].previousValue !== undefined) {
      this.myTasks = changes["myTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }

    if (
      changes["archivedTasks"] &&
      changes["archivedTasks"].previousValue !== undefined
    ) {
      this.archivedTasks = changes["archivedTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }

    if (
      changes["bulkArchive"] &&
      changes["bulkArchive"].previousValue !== undefined
    ) {
      // Reset all archive selections when bulkArchive value changes
      this.taskList.forEach(task => {
        task.archiveSelected = false;
      });
      this.archivedList.emit([]);
    }

    if (changes["taskType"]) {
      if (
        changes["taskType"].currentValue === 2 ||
        changes["taskType"].currentValue === "2"
      ) {
        this.priorityTypeList = [
          this.priorityTypeList[0],
          this.priorityTypeList[3],
        ];
      } else {
        this.priorityTypeList = this.prioirtyKeys();
      }
    }
  }

  showDialogSummary() {
    this.showSummarykModal = !this.showSummarykModal;
  }

  closeAddTask() {
    this.displayAddTaskModal = false;
    if (!this.displayTaskDetailModal) {
      this.taskIdSelected = 0;
    } else {
      this.child.getTaskDetail();
    }
  }

  showAddTask() {
    this.showTaskModal = !this.showTaskModal;
  }

  getPriorityByTitle(id: number): string {
    return this.priorityLevel[id];
  }

  getPriorityId(key: keyof typeof PriorityTypeEnums) {
    return this.priorityEnum[key] ?? "";
  }

  getSalesTaskAsList() {
    return Object.entries(EnumSalesTaskStatus)
      .filter(([key]) => isNaN(Number(key)))
      .map(([key, value]) => ({
        label: key.replace(/([a-z])([A-Z])/g, "$1 $2"),
        value,
      }));
  }

  prioirtyKeys(): string[] {
    const keys = Object.keys(this.priorityEnum);
    return keys.splice(keys.length / 2, keys.length - 1);
  }

  getStatusId(key: string) {
    return (
      this.salesStatusEnum[key as keyof typeof EnumSalesTaskStatus] ??
      this.productionStatusEnum[key as keyof typeof WorkflowStatusEnum] ??
      ""
    );
  }

  stateKeys() {
    if (Number(this.taskType) === Number(TaskTypeEnum.Production)) {
      return this._sharedService.enumToList(this.workflowStatusList);
    } else if (Number(this.taskType) === Number(TaskTypeEnum.Sales)) {
      return this._sharedService.enumToList(this.taskStatusKeyPairsSalesByName);
    } else {
      return this._sharedService.enumToList({
        ...this.workflowStatusList,
        ...this.taskStatusKeyPairsSalesByName,
      });
    }
  }

  getWorkflowStatusList() {
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        this.workflowStatusList = {};
        this.prodStatusDropDownList = [];
        const statusEnums: Record<string, number> = {};
        if (res?.data) {
          res.data.forEach((status: { status: string; id: number }) => {
            if (status.id !== 9) {
              statusEnums[status.status] = status.id;
              this.prodStatusDropDownList.push({
                label: status.status,
                value: status.id,
              });
            }
          });
          this.workflowStatusList = statusEnums;
          this.getAllState = {
            ...this.getAllState,
            ...this.workflowStatusList,
          };
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
      },
    });
  }

  showEditTask() {
    this.showEditTaskModal = !this.showEditTaskModal;
    this.getAllTaskList(this.lazyLoadEvent);
  }

  showDialog() {
    this.taskIdSelected = 0;
    this.displayAddTaskModal = true;
  }

  showTaskDetailModal() {
    this.displayTaskDetailModal = true;
  }

  closeTaskDetailModal(event: {
    added: boolean;
    actionType: "Add" | "Edit";
    hasFormChanged: boolean;
  }) {
    this.displayTaskDetailModal = false;
    if (event.hasFormChanged || event.actionType === "Add") {
      this.getAllTaskList(this.lazyLoadEvent);
    }
  }

  showSidebar() {
    this.displaySidebar = true;
  }

  hideSideBar() {
    this.displaySidebar = false;
  }

  onFilterInput($event: Event, extraFilter?: string, calendar?: boolean) {
    if (this.filterTextChanged.observers.length === 0) {
      if (extraFilter && this.lazyLoadEvent.filters) {
        if (!this.lazyLoadEvent.filters[extraFilter]) {
          this.lazyLoadEvent.filters[extraFilter] = {
            value: null,
            matchMode: "startsWith",
          };
        }
        const filter = this.lazyLoadEvent.filters[
          extraFilter
        ] as FilterMetadata;
        if (calendar && $event instanceof Date) {
          filter.value = this.datePipe.transform(
            $event,
            "yyyy-MM-dd HH:mm:ss.SSS"
          );
        } else if ("value" in $event) {
          filter.value = $event.value;
        }
        filter.matchMode = "startsWith";
      }
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllTaskList(this.lazyLoadEvent);
        });
    }
    this.showClearFilter.emit(true);
    this.filterTextChanged.next($event);
  }

  triggerFunction(
    globalFilterValue: GenericFilterRequestDto[],
    taskType?: number
  ) {
    if (taskType) {
      this.taskType = taskType;
    }
    this.clearColumns.subscribe(value => {
      if (value && this.lazyLoadEvent?.filters) {
        if (this.lazyLoadEvent.filters) {
          for (const key in this.lazyLoadEvent.filters) {
            const filter = this.lazyLoadEvent.filters[key];
            if (filter && !Array.isArray(filter)) {
              filter.value = null;
            }
          }
        }
      }
    });
    this.stateList = this.stateKeys();
    this.globalFilter = globalFilterValue;

    // Disable bulk archive mode when filters are applied
    if (this.bulkArchive) {
      this.disableBulkArchive.emit();
    }

    this.getAllTaskList(this.lazyLoadEvent, globalFilterValue);
  }

  getStatusColor(status: number, type: number) {
    const taskColorCodes =
      type === 1 ? this.salesTaskColorCodes : this.prodTaskColorCodes;
    const defaultColorKey = type === 1 ? "13" : "2";
    return taskColorCodes[status.toString()] ?? taskColorCodes[defaultColorKey];
  }

  populateFilterFromDropDown(
    event: SelectChangeEvent | Date,
    column?: string,
    calendar?: boolean
  ) {
    if (column && this.lazyLoadEvent?.filters) {
      const filter = this.lazyLoadEvent.filters[column] as FilterMetadata;
      if (!filter) {
        this.lazyLoadEvent.filters[column] = {
          value: null,
          matchMode: "startsWith",
        };
      }

      if (calendar && event instanceof Date) {
        this.lazyLoadEvent.filters[column] = {
          value: this.datePipe.transform(event, "yyyy-MM-dd HH:mm:ss.SSS"),
          matchMode: "startsWith",
        };
      } else if ("value" in event) {
        this.lazyLoadEvent.filters[column] = {
          value: event.value,
          matchMode: "startsWith",
        };
      }
    }

    // Disable bulk archive mode when dropdown filters are applied
    if (this.bulkArchive) {
      this.disableBulkArchive.emit();
    }

    this.getAllTaskList(this.lazyLoadEvent);
    this.showClearFilter.emit(true);
  }

  onTitleFocus(task: GetAllTaskResponse) {
    this.originalTitle = task.title;
  }

  onTitleMouseDown(event: MouseEvent) {
    const input = event.target as HTMLInputElement;
    input.setPointerCapture((event as PointerEvent).pointerId || 1);
  }

  onTitleMouseUp(event: MouseEvent) {
    const input = event.target as HTMLInputElement;
    if (input.hasPointerCapture((event as PointerEvent).pointerId || 1)) {
      input.releasePointerCapture((event as PointerEvent).pointerId || 1);
    }
  }

  onNicknameFocus(task: GetAllTaskResponse) {
    this.originalNickName = task.nickName;
  }

  getAllTaskList(
    event: TableLazyLoadEvent,
    globalFilterValue?: GenericFilterRequestDto[]
  ) {
    this.lazyLoadEvent = event;
    this._loaderService.setLoaderState(true);
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      const data = {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;

      return data;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    filter.forEach(x => {
      if (x.columnName == "client") {
        x.columnName = "NameAliasD365";
        x.tableName = "clients";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobName";
        x.tableName = "workflowheaders";
      }
      if (x.columnName == "buyer") {
        x.columnName = "Buyer";
        x.tableName = "BuyerField";
      }
      if (x.columnName == "esd") {
        x.columnName = "ShipDateD365";
        x.tableName = "ProjectWorkflowLines";
      }
      if (x.columnName == "ihd") {
        x.columnName = "InHandsDateD365";
        x.tableName = "SaleOrderHeaders";
      }
      if (x.columnName == "title") {
        x.columnName = "Title";
        x.tableName = "UserTasks";
      }
      if (x.columnName == "description") {
        x.columnName = "Description";
        x.tableName = "UserTasks";
      }
      if (x.columnName == "duedate") {
        x.columnName = "DueDate";
        x.tableName = "UserTasks";
      }
      if (x.columnName == "assignedto") {
        x.columnName = "PersonnelNumber";
        x.tableName = "taskassignmentsbyname";
        x.value =
          (x.value ?? "") === ""
            ? (this.relatedGlobalFilterVal("personnelNumber") ?? "")
            : x.value;
      }
      if (x.columnName == "owner") {
        x.columnName = "Owner";
        x.tableName = "Employee";
      }
      if (x.columnName == "note") {
        x.columnName = "Notes";
        x.tableName = "UserTasks";
      }
      if (x.columnName == "priorityType") {
        x.columnName = "PriorityType";
        x.tableName = "Usertasks";
        x.value = isNaN(Number(x.value))
          ? (this.getPriorityId(
              x.value as keyof typeof PriorityTypeEnums
            )?.toString() ??
            this.relatedGlobalFilterVal("priorityType") ??
            "")
          : x.value.toString();
      }
      if (x.columnName == "status") {
        x.columnName = "Status";
        x.tableName = "TaskStatus";
        x.value =
          this.getAllState[x.value]?.toString() ??
          this.relatedGlobalFilterVal("status");
      }
      if (x.columnName == "createddate") {
        x.columnName = "CreatedDate";
        x.tableName = "Usertasks";
      }
      if (x.columnName == "createdby") {
        x.columnName = "CreatedBy";
        x.tableName = "Usertasks";
      }
      if (x.columnName == "poNumber") {
        x.columnName = "PONumber";
        x.tableName = "SaleOrderHeaders";
      }
      if (x.columnName == "nickName") {
        x.columnName = "NickName";
        x.tableName = "SaleOrderHeaders";
      }
      if (x.columnName == "supplier") {
        x.columnName = "Supplier";
        x.tableName = "SaleOrderHeaders";
      }
    });
    filter.push({
      columnName: "Id",
      matchMode: "equals",
      tableName: "workflowheaders",
      value: this.relatedGlobalFilterVal("Id") ?? "",
    });
    filter.push({
      columnName: "RemindMe",
      matchMode: "equals",
      tableName: "UserTasks",
      value: this.relatedGlobalFilterVal("RemindMe") ?? "",
    });
    filter.push({
      columnName: "Name",
      matchMode: "equals",
      tableName: "Tags",
      value: this.relatedGlobalFilterVal("Name") ?? "",
    });
    if (this.taskType) {
      filter.push({
        columnName: "TaskType",
        matchMode: "equals",
        tableName: "UserTasks",
        value: this.taskType.toString() === "0" ? "" : this.taskType.toString(),
      });
    }
    const nonDuplicateFilters = filter.filter(
      newFilter =>
        !globalFilterValue?.some(
          (filter: GenericFilterRequestDto) =>
            filter.columnName === newFilter.columnName
        )
    );
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: globalFilterValue
        ? [...globalFilterValue, ...nonDuplicateFilters]
        : filter,
      sort: sortArray,
      listViewType: ViewTypeEnum.List,
      myTask: this.myTasks,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      archivedTask: this.archivedTasks,
    };

    this._taskManagement.getAllProjectWorkFlowTaskList(request).subscribe({
      next: async res => {
        this.totalRecords = 0;
        this.taskList = [];

        if (res?.data) {
          this.totalRecords = res.totalRecords ?? 0;
          this.taskList = res.data.map(item => {
            return {
              ...item,
              priority: this.getPriorityByTitle(item.priorityType),
              status: item.status,
              ihd: item.ihd,
              esd: item.esd,
              dueDate: item.dueDate,
              calendarDueDate: new Date(item.dueDate),
            };
          });
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Listed Tasks");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  relatedGlobalFilterVal(column: string): string | undefined {
    const val = this.globalFilter?.find(
      f => f.columnName.toLowerCase() === column.toLowerCase()
    )?.value;
    return val ?? "";
  }

  onPriorityChangeDpdown(taskId: number, event: SelectChangeEvent) {
    if (taskId && event.value) {
      this.displaySmallLoader.emit(true);
      const request: UpdateTaskPriority = {
        taskId: taskId,
        priorityType: Number(event.value),
      };
      this._taskManagement.updateTaskPrioirty(request).subscribe({
        next: async res => {
          if (res?.data) {
            this.displaySmallLoader.emit(false);
            this._toastr.success(
              "Success",
              "Task Priority updated Successfully"
            );
            this.getAllTaskList(this.lazyLoadEvent);
          } else {
            this.displaySmallLoader.emit(false);
            this._toastr.error("Error", "Failed to update Task Priority");
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to update Task Priority");
        },
      });
    }
  }

  openNotesModal(taskId: number, notes: string) {
    this.taskId = taskId;
    this.notes = notes;
    this.showNotesModal = true;
  }

  submitNotes() {
    if (this.taskId != 0 && this.notes != "") {
      this.showSmallLoader = true;
      const request: AddTaskNotes = {
        taskId: this.taskId,
        notes: this.notes,
      };
      this._taskManagement.addTaskNotes(request).subscribe({
        next: async res => {
          if (res?.data) {
            this.getAllTaskList(this.lazyLoadEvent);
            this.showSmallLoader = false;
            this.showNotesModal = false;
            this._toastr.success("Success", "Notes Added Successfully");
          } else {
            this.showSmallLoader = false;
            this.showNotesModal = false;
            this._toastr.error("Error", "Failed to Add Notes");
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this.showNotesModal = false;
          this._toastr.error("Error", "Failed to Add Notes");
        },
      });
    }
  }

  redirectToTaskSummary(task: number) {
    this.displayTaskDetailModal = true;
    this.taskIdSelected = task;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  formatDate(date: string) {
    return this.datePipe.transform(date, "MM/dd");
  }

  getPriorityTypeTitle(priorityType: number) {
    return this.priorityLevel[priorityType];
  }

  getTaskTypeTitle(taskType: number) {
    return this.taskTypeKey[taskType];
  }

  getTaskStatusTitleSales(taskStatus: number) {
    return this.taskStatusKeyPairsSales[taskStatus];
  }

  getAcronym(word: string) {
    return word?.match(/\b(\w)/g)?.join("");
  }
  getTaskStatusTitleProduction(taskStatus: number) {
    return this.taskStatusKeyPairsProduction[taskStatus];
  }

  getPaddedWorkflowId(workflowId: number) {
    return workflowId?.toString().padStart(6, "0");
  }

  closeWorkflowModal() {
    this.salesOrderId = "";
    this.workflowId = 0;
    this.displayProdWorkflowSummary = false;
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  getColor(name: string) {
    return getColorForName(name);
  }
  openWorkflowModal(workflowId: number, salesOrderId: string) {
    if (workflowId) {
      this.workflowId = workflowId;
      this.salesOrderId = salesOrderId;
      this.displayProdWorkflowSummary = true;
    }
  }

  validateDueDate(
    taskDate: string,
    status: number,
    taskType: number,
    isExternal: boolean,
    isAdmin: boolean
  ) {
    if (isExternal && !isAdmin) {
      return false;
    } else {
      return this.currentDate > new Date(taskDate) &&
        status !== 17 &&
        taskType === 1
        ? true
        : false;
    }
  }

  sortRow(event: TableRowReorderEvent) {
    if (
      typeof event.dragIndex !== "number" ||
      typeof event.dropIndex !== "number"
    ) {
      return;
    }

    const previousItem = this.taskList[event.dropIndex - 1];
    const nextItem = this.taskList[event.dropIndex + 1];
    const droppedItem = this.taskList[event.dropIndex];

    const isPreviousValid =
      previousItem != null &&
      this.datePipe.transform(previousItem.dueDate, "yyyy-MM-dd") ===
        this.datePipe.transform(droppedItem.dueDate, "yyyy-MM-dd") &&
      previousItem.priorityType === droppedItem.priorityType &&
      previousItem.projectWorkflowId === droppedItem.projectWorkflowId;

    const isNextValid =
      nextItem != null &&
      this.datePipe.transform(nextItem.dueDate, "yyyy-MM-dd") ===
        this.datePipe.transform(droppedItem.dueDate, "yyyy-MM-dd") &&
      nextItem.priorityType === droppedItem.priorityType &&
      nextItem.projectWorkflowId === droppedItem.projectWorkflowId;

    if (!isPreviousValid && !isNextValid) {
      this._toastr.error(
        "Error",
        "Item cannot sort due to specified parameters"
      );
      this.getAllTaskList(this.lazyLoadEvent);
      return;
    }

    const filteredTaskList = this.taskList.filter(
      task =>
        task.priorityType == droppedItem.priorityType &&
        new Date(task.dueDate).getDate() ==
          new Date(droppedItem.dueDate).getDate()
    );
    filteredTaskList.forEach((element, index) => {
      element.sortOrder = index + 1;
    });

    const request: AddTaskOrder[] = filteredTaskList.map(element => ({
      TaskId: element.taskId,
      DueDate: this.datePipe.transform(element.dueDate, "yyyy-MM-dd"),
      PriorityType: element.priorityType,
      SortOrder: element.sortOrder,
      ProjectHeaderId: element.projectWorkflowId,
    }));

    this._taskManagement.updateTaskOrder(request).subscribe({
      next: async res => {
        if (res && res.status === "Success") {
          this.getAllTaskList(this.lazyLoadEvent);
          this._toastr.success("Success", "Sorting Added Successfully");
        } else {
          this.showSmallLoader = false;
          this.showNotesModal = false;
          this._toastr.error("Error", "Failed to Add Operation");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this.showNotesModal = false;
        this._toastr.error("Error", "Failed to Add Operation");
      },
    });
  }

  onEditAssignedTo(task: GetAllTaskResponse) {
    this.ownerList = [];
    if (task.client) {
      this.getOwnersByProject(task.client);
    } else {
      this.getDefaultAssignee();
    }
  }

  getOwnersByProject(client: string) {
    if (client) {
      this._samplepoListingService.getBCForSalesOrder(client).subscribe({
        next: res => {
          this.ownerList = [];
          if (res.data != null && res.data.length > 0) {
            res.data.forEach((item: GetBCForSalesOrderDto) => {
              if (item.projectName) {
                const user = {
                  name: item.projectName,
                  personalNumber: item.personnelNumber,
                };
                this.ownerList.push(user);
                this.getBacForSalesOrder(item.personnelNumber);
              }
            });
            // this.ownerList.push({
            //   name: res.data[0].projectName,
            //   personalNumber: res.data[0].personnelNumber,
            // });
            // this.getBacForSalesOrder(res.data[0].personnelNumber);
          }
        },
      });
    }
  }

  getBacForSalesOrder(personnelNumber: string, def?: boolean) {
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                this.ownerList?.push({
                  name: item.name,
                  personalNumber: item.personnelNumber,
                });
                if (def) {
                  this.ownerListDefault?.push({
                    name: item.name,
                    personalNumber: item.personnelNumber,
                  });
                }
              }
            });
          }
        },
      });
  }

  onTaskFieldEdit(
    task: GetAllTaskResponse | ProjectWorkflowDetail,
    column: string
  ) {
    if (
      column === "calendarDueDate" ||
      column === "ihd" ||
      (column === "esd" && "esd" in task && task.esd)
    ) {
      if (column in task && task[column as keyof typeof task]) {
        const dateValue = task[column as keyof typeof task];
        // Convert to Date and adjust to local timezone to prevent UTC conversion issues
        const inputDate = new Date(dateValue as string | Date);
        const localDate = new Date(
          inputDate.getFullYear(),
          inputDate.getMonth(),
          inputDate.getDate()
        );
        const formattedDate = this.datePipe.transform(
          localDate,
          "yyyy-MM-dd HH:mm:ss.SSS"
        );
        if (column === "calendarDueDate") {
          (task as GetAllTaskResponse)[column] = formattedDate
            ? new Date(formattedDate)
            : new Date();
        } else {
          (task as GetAllTaskResponse)[column] = formattedDate ?? "";
        }
      }
    }

    if (column === "title" && "title" in task && task.title.trim() === "") {
      this._toastr.error("Error", "Task Title should not be empty");
      return;
    } else if (
      column === "title" &&
      "title" in task &&
      this.originalTitle === task.title
    ) {
      return;
    } else if (
      column === "buyerName" &&
      this.originalBuyerNameWithout === task.buyerName
    ) {
      return;
    } else if (
      column === "customerNameWithNoProject" &&
      this.originalClientNameWithout === task.customerNameWithNoProject
    ) {
      return;
    }

    if (
      column === "nickName" &&
      "nickName" in task &&
      this.originalNickName === task.nickName
    ) {
      return;
    }

    this.displaySmallLoader.emit(true);

    if (column === "assigned To") {
      column = "assignment";
    }
    // Get the correct value for date fields to avoid timezone issues
    let payloadValue = null;
    if (column in task) {
      if (
        column === "calendarDueDate" ||
        column === "ihd" ||
        column === "esd"
      ) {
        const dateValue = task[column as keyof typeof task];
        if (dateValue) {
          const inputDate = new Date(dateValue as string | Date);
          const localDate = new Date(
            inputDate.getFullYear(),
            inputDate.getMonth(),
            inputDate.getDate()
          );
          payloadValue = this.datePipe.transform(
            localDate,
            "yyyy-MM-dd HH:mm:ss.SSS"
          );
        }
      } else {
        payloadValue =
          "taskId" in task
            ? task[column as keyof GetAllTaskResponse]
            : task[column as keyof ProjectWorkflowDetail];
      }
    }

    if (column === "buyerName" || column === "buyer") {
      payloadValue = task.buyerName ?? "";
      column = "buyer";
    }

    const payload = {
      taskId: "taskId" in task ? task.taskId : 0,
      column: column == "calendarDueDate" ? "dueDate" : column,
      value: payloadValue,
      lineRecId: "lineRecId" in task ? task.lineRecId : 0,
      saleOrderId: task.salesOrderId,
      isBuyerChange: this.buyerChange,
    } as UpdateTaskLine;
    this._taskManagement.UpdateTaskLine(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          if (column === "title" && "taskId" in task) {
            this.sendComment(task[column], task.taskId);
          }
          this.displaySmallLoader.emit(false);
          this._toastr.success("Success", "Task Updated Successfully");
          this.getAllTaskList(this.lazyLoadEvent);
        } else {
          this.displaySmallLoader.emit(false);
          this._toastr.error("Error", "Failed to Update Task");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this._toastr.error("Error", "Failed to Update Task");
      },
    });
  }
  onStatusDropDownChange(taskId: number, value: number, taskType: number) {
    if (taskId && value) {
      this.displaySmallLoader.emit(true);
      this._taskManagement.updateStatus(taskId, value).subscribe({
        next: res => {
          this.displaySmallLoader.emit(false);
          if (res.status.toLowerCase() === "success") {
            this.sendComment(
              `Status changed: ${
                taskType === 1
                  ? this.getTaskStatusTitleSales(value)
                  : this.getTaskStatusTitleProduction(value)
              }`,
              taskId
            );
            this._toastr.success(
              "You have successfully updated the Status",
              "Success"
            );
            this.getAllTaskList(this.lazyLoadEvent);
          } else {
            this._toastr.error("Error updating the status", "Error");
          }
        },
      });
    }
  }

  addLineBreakAfterThreeWords(input: string) {
    const words = input.split(" ");
    if (words.length < 2) {
      return input;
    }

    return words
      .map((word, index) => ((index + 1) % 2 === 0 ? word + "<br>" : word))
      .join(" ");
  }

  limitString(input: string, limit: number) {
    const words = input.split(" ");
    let charCount = 0;
    let result = "";

    for (let i = 0; i < words.length; i++) {
      charCount += words[i].length + (i > 0 ? 1 : 0);

      result += words[i];

      if ((i + 1) % 5 === 0 || charCount >= limit) {
        result += "<br>";
        charCount = 0;
      }

      if (i < words.length - 1) {
        result += " ";
      }
    }

    return result.trim();
  }

  onBuyerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
  }

  searchBuyerName() {
    this.showSmallLoader = true;
    this._taskManagement
      .getAllBuyers(
        {} as {
          buyer: string;
          client: string;
        }
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.buyerLists = res.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getBuyer(event: MouseEvent | Event, mydrop: Popover, client: string) {
    const target = event.target as HTMLInputElement;
    const searchValue = target.value;
    this.showSmallLoader = true;
    mydrop.show(event);
    if (this.buyerLists?.length > 0 && searchValue !== "") {
      this.buyerLists = this.buyerLists.filter(list =>
        list.buyer.toLowerCase().includes(searchValue.toLowerCase())
      );
      this.showSmallLoader = false;
    } else {
      const request = {
        buyer: searchValue,
        client: client || "",
      } as {
        client: string;
        buyer: string;
      };
      this._taskManagement
        .getAllBuyers(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover,
    task: ProjectWorkflowDetail
  ) {
    this.buyerChange = false;
    if (
      !task.buyerName ||
      (task.projectWorkflowId && task.buyerName !== event.buyer)
    ) {
      this.buyerChange = true;
      this.selectedBuyer = event.buyer;
      if (task.buyerName) {
        this.changeAlertMessage = replaceString(
          this.changeAlertMessage,
          task.buyerName
        );
        this.changeAlertVisible = true;
      }
    }
    task.buyerName = event.buyer;
    this.selectedProject = task;
    if (!this.changeAlertVisible && this.selectedProject) {
      this.onTaskFieldEdit(this.selectedProject, "buyer");
    }
    buyerProspetToggle.hide();
  }

  confirmChangeBuyer(event: boolean) {
    if (event) {
      if (this.selectedProject) {
        this.onTaskFieldEdit(this.selectedProject, "buyer");
      }
      this.selectedProject = null;
      this.selectedBuyer = "";
    }
    this.changeBuyerVisible = false;
  }

  confirmAlertBuyer(event: boolean) {
    this.changeAlertVisible = false;
    if (!event) {
      this.selectedBuyer = this.selectedProject?.buyerName ?? "";
    } else {
      this.changeBuyerVisible = true;
    }
  }

  getDefaultAssignee() {
    this._taskManagement
      .getDefaultAssignees()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                this.ownerList?.push({
                  name: item.name,
                  personalNumber: item.personalNumber,
                });
                if (
                  !this.ownerListDefault?.some(
                    owner => owner.name === item.name
                  )
                ) {
                  this.ownerListDefault?.push({
                    name: item.name,
                    personalNumber: item.personalNumber,
                  });
                }
              }
            });
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to get assignees");
        },
      });
  }

  onEditAssignedToClick(task: GetAllTaskResponse, value: string) {
    const payload = {
      taskId: task.taskId,
      column: "assignment",
      value: value,
    } as UpdateTaskLine;
    this.displaySmallLoader.emit(true);
    this._taskManagement.UpdateTaskLine(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          this.displaySmallLoader.emit(false);
          this._toastr.success("Success", "Task Updated Successfully");
          this.getAllTaskList(this.lazyLoadEvent);
        } else {
          this.displaySmallLoader.emit(false);
          this._toastr.error("Error", "Failed to Update Task");
        }
      },
      error: () => {
        this.showSmallLoader = false;
        this._toastr.error("Error", "Failed to Update Task");
      },
    });
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text).then(
      () => {
        this._toastr.success("Text copied to clipboard", "Success");
      },
      err => {
        console.error("Failed to copy text: ", err);
      }
    );
  }

  archiveEvent(task: GetAllTaskResponse, status: boolean) {
    const eventTxt = status ? "Archived" : "UnArchived";
    this.archiveMessage = replaceString(
      this.archiveMessage,
      task.title,
      eventTxt
    );
    this.archivedTask = task.taskId;
    this.archivedTaskStatus = status;
    this.archiveAlertVisible = true;
  }

  confirmArchive(event: boolean) {
    this.archiveAlertVisible = false;
    this.archiveMessage = "You want to mark <b>{0}</b> as {1}.";
    if (event && this.archivedTask) {
      const payload = {
        taskId: this.archivedTask,
        archive: this.archivedTaskStatus,
      };
      this.displaySmallLoader.emit(true);
      this._taskManagement.MarkAsArchive(payload).subscribe({
        next: async res => {
          if (res && res.status.toLowerCase() === "success") {
            this.displaySmallLoader.emit(false);
            this._toastr.success(
              "Success",
              "Task archive status has been changed"
            );
            this.getAllTaskList(this.lazyLoadEvent);
          } else {
            this.displaySmallLoader.emit(false);
            this._toastr.error("Error", "Failed to Update Task");
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to Update Task");
        },
      });
    }
  }

  getLineIHDClass(task: GetAllTaskResponse) {
    const today = new Date().setHours(0, 0, 0, 0);
    const inHandDate = task.ihd
      ? new Date(task.ihd).setHours(0, 0, 0, 0)
      : null;
    if (
      task.taskType === TaskTypeEnum.Sales &&
      inHandDate &&
      inHandDate < today
    ) {
      return "danger";
    }
    if (task.taskType === TaskTypeEnum.Production) {
      const shipDate = task.shipDateD365
        ? new Date(task.shipDateD365).setHours(0, 0, 0, 0)
        : null;
      const deliveredDate = task.trackingsDeliveryDate
        ? new Date(task.trackingsDeliveryDate).setHours(0, 0, 0, 0)
        : today;
      if (
        task.isFirmInHand &&
        ((inHandDate && inHandDate < deliveredDate && task.trackingCount > 0) ||
          (inHandDate && inHandDate < deliveredDate) ||
          (shipDate && inHandDate && shipDate > inHandDate))
      ) {
        return "firm-danger";
      } else if (
        task.isFirmInHand ||
        (inHandDate && inHandDate < deliveredDate && task.trackingCount > 0) ||
        (inHandDate && inHandDate < deliveredDate) ||
        (shipDate && inHandDate && shipDate > inHandDate)
      ) {
        return "danger";
      } else if (
        task.shipDateD365 &&
        task.shipDateD365 != "" &&
        task.trackingCount !== 0 &&
        (!task.ihd || task.ihd === "")
      ) {
        return "warning";
      }
    }
    return "";
  }

  redirectOrderSummary(salesOrderId: string) {
    if (salesOrderId) {
      const url = this._router.serializeUrl(
        this._router.createUrlTree([`/orders/order-summary/${salesOrderId}`])
      );
      window.open(url, "_blank");
    }
  }

  onRowToggle(event: CheckboxChangeEvent, task: GetAllTaskResponse) {
    task.archiveSelected = !!event.checked;
    const filteredArchive = (this.taskList ?? []).filter(
      t => !!t.archiveSelected
    );
    this.archivedList.emit(filteredArchive);
  }
  sendComment(comment: string, taskId: number): boolean {
    let status = false;
    if (taskId) {
      const commentPayload = {
        comment: comment,
        taskId: taskId,
      } as createCommentDto;
      this._taskManagement
        .addCommentinTask(commentPayload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: async res => {
            if (res.status.toLowerCase() === "success") {
              status = true;
            }
          },
        });
    }
    return status;
  }

  getTooltipContent(obj: number | null | undefined, assignedTo: string) {
    if (obj && obj > 0) {
      // Find user from the assigned users list by matching name
      const user = this.allAssignedUserList.find(u => u.name === assignedTo);
      if (user) {
        // Use the user data from the list instead of making API call
        this.userAvatorDetails.name = user.name ?? "";
        this.userAvatorDetails.email = user.loginEmail ?? "";
        this.userAvatorDetails.personalNumber = user.personalNumber ?? "";
        this.userAvatorDetails.locationName = user.locationName ?? "";
        this.userAvatorDetails.profileImageUrl =
          "../../../assets/images/avatar-default.webp";

        this.showUserAvatarDetails = true;
        // Fetch profile picture
        if (user.loginEmail) {
          this.fetchUserProfile(user.loginEmail);
        }
      } else {
        // Fallback to API call if user not found in list
        this.getUserAvatarDetailsByUserId(obj);
      }
    }
  }

  showAvatarPopover(
    event: MouseEvent,
    userId: number | null | undefined,
    assignedTo: string
  ): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.currentAvatarTarget = event.currentTarget as HTMLElement;

    // First set up the content
    this.showUserAvatarDetails = true;
    this.getTooltipContent(userId, assignedTo);

    // Wait a short moment for the content to be rendered, then show popover
    setTimeout(() => {
      if (this.avatarUserPopover && this.currentAvatarTarget) {
        this.avatarUserPopover.show(event, this.currentAvatarTarget);
      }
    }, 100);
  }

  hideAvatarPopover(): void {
    this.hideTimeout = setTimeout(() => {
      if (this.avatarUserPopover) {
        this.avatarUserPopover.hide();
      }
      this.onAvatarLeave();
    }, 200);
  }

  keepPopoverOpen(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  onAvatarLeave() {
    this.clearAvatarDetails();
    this.showUserAvatarDetails = false;
    this.currentAvatarTarget = null;
  }

  clearAvatarDetails() {
    this.userAvatorDetails = {} as avatarUserDetailsDto;
    this.userAvatorDetails = {
      name: "",
      email: "",
      personalNumber: "",
      locationName: "",
      profileImageUrl: "../../../assets/images/avatar-default.webp",
    } as avatarUserDetailsDto;
  }

  getUserAvatarDetailsByUserId(userId: number) {
    this.isLoading = true;
    this._profileFormService.GetUserAvatarDetailsByUserId(userId).subscribe({
      next: async (res: GenericResponseDto<GetUserAvatarDetailsDto>) => {
        if (res.data != null) {
          this.userAvatorDetails.name = res.data.name ?? "";
          this.userAvatorDetails.email = res.data.email ?? "";
          this.userAvatorDetails.personalNumber =
            res.data.personnelNumber ?? "";
          this.userAvatorDetails.locationName = res.data.locationName ?? "";
          this.userAvatorDetails.profileImageUrl =
            "../../../assets/images/avatar-default.webp";
          this.fetchUserProfile(res.data.email ?? "");
          this.showUserAvatarDetails = true;
        }
      },
      error: () => {
        this.showUserAvatarDetails = false;
        this.isLoading = false;
      },
    });
  }

  fetchUserProfile(loginEmail: string): void {
    this._msalApisService.getUserProfilePicture(loginEmail).subscribe({
      next: (res: Blob) => {
        const urlCreator = window.URL || window.webkitURL;
        this.userAvatorDetails.profileImageUrl =
          this._domSanitizer.bypassSecurityTrustUrl(
            urlCreator.createObjectURL(res)
          );
        this.isLoading = false;
      },
      error: () => {
        this.userAvatorDetails.profileImageUrl =
          "../../../assets/images/avatar-default.webp";
        this.isLoading = false;
      },
    });
  }

  onClientNameWithoutProjectFocus(
    clientNameWithoutProject: string | undefined
  ) {
    this.originalClientNameWithout = clientNameWithoutProject ?? "";
  }

  onBuyerNameWithoutProjectFocus(buyerNameWithoutProject: string | undefined) {
    this.originalBuyerNameWithout = buyerNameWithoutProject ?? "";
  }

  showContactDialog(client: string) {
    if (client !== "") {
      this.clientId = client;
      this.addClientContact.type = "Buyer";
      this.displayAddContact = true;
    }
  }

  populateContactAddedInfo(buyer: string) {
    this.taskHeaderEdit?.popolateBuyerNameAfterContactAdded(buyer);
  }
}
